import { render, staticRenderFns } from "./DigitiseFlowCancelConfirmModal.vue?vue&type=template&id=1208d050&scoped=true&"
import script from "./DigitiseFlowCancelConfirmModal.vue?vue&type=script&lang=js&"
export * from "./DigitiseFlowCancelConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./DigitiseFlowCancelConfirmModal.vue?vue&type=style&index=0&id=1208d050&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1208d050",
  null
  
)

export default component.exports